export default (response) => {
  return Promise.resolve(response)
}
